import moment from "moment";

export const setprovideScheduleStartDate = ({ startDate }) =>
  sessionStorage.setItem("provideScheduleStartDate", startDate.toISOString());

export const getprovideScheduleStartDate = () => {
  const date = sessionStorage.getItem("provideScheduleStartDate");
  return date ? moment(date) : null;
};

export const removeProvideScheduleStartDate = () =>
  sessionStorage.removeItem("provideScheduleStartDate");

export const setProvideScheduleFilters = ({ id, filters }) =>
  localStorage.setItem(`psFilters-${id}`, JSON.stringify(filters));

export const getProvideScheduleFilters = ({ id }) =>
  JSON.parse(localStorage.getItem(`psFilters-${id}`));
